import {Component} from '@angular/core';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {ActivatedRoute, Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import { MatDialog } from '@angular/material/dialog';
import {TaskManagerState} from '../../store/task-manager.reducer';
import {Store} from '@ngrx/store';
import {Location} from '@angular/common';
import {TaskManagerService} from '../../services/task-manager.service';
import {Configuration} from '@shared/models/configuration';
import {TaskManagerKanbanComponent} from '../task-manager-kanban/task-manager-kanban.component';
import {CommandService} from '@core/services/command.service';
import {DuplicateTaskCommand} from '../../commands/task-manager.command';
import {SnackBarService} from '@core/services/snack-bar.service';

@Component({
    standalone: false,
    selector: 'particle-task-manager-ticket-list',
  templateUrl: './task-manager-ticket-list.component.html',
  styleUrls: ['./task-manager-ticket-list.component.scss']
})
export class TaskManagerTicketListComponent extends TaskManagerKanbanComponent {
  invalidateSubject: InvalidateSubject;
  sourceKey: string;
  endpoint = 'TaskManagerApi';
  isSupportTicketGrid: boolean;

  constructor(protected activatedRoute: ActivatedRoute,
              protected taskManagerStore: Store<TaskManagerState>,
              public dialog: MatDialog,
              protected dialogService: DialogService,
              protected location: Location,
              protected route: Router,
              protected taskManagerService: TaskManagerService,
              protected commandService: CommandService,
              protected snackBarService: SnackBarService) {
    super(activatedRoute, taskManagerStore, dialog, dialogService, location, route, taskManagerService, commandService, snackBarService);
    this.invalidateSubject = new InvalidateSubject();
    this.sourceKey = 'BoardTasks';
    this.scope = 1;
    this.isSupportTicketGrid = false;
  }

  protected onLoadBoard(selectedBoard) {
    super.onLoadBoard(selectedBoard);
    const config = Configuration.getSmartGridConfig(this.sourceKey);
    config.Parameters['BOARD_ID'] = selectedBoard.id;
    config.Parameters['SCOPE'] = selectedBoard.scopeInt;
    config.Parameters['SHOW_ARCHIVED'] = this.showArchived;
    this.invalidateSubject.invalidate();
  }

  getTypeView() {
    return 'grid';
  }

  onGridCellValueChange(event) {
    if (event.action) {
      switch (event.action.id) {
        case 'Open':
          this.onOpenTaskModalClicked({
            board: this.selectedBoard,
            card: event.item.cells.Title.value,
            parentUrl: this.getBoardUrl(this.selectedBoard)
          });
          break;
        case 'Duplicate':
          // const duplicateTaskCommand = new DuplicateTaskCommand(event.item.id);
          // duplicateTaskCommand.scope = this.selectedBoard.scopeInt;
          // this.commandService.executeCommand(duplicateTaskCommand)
          //   .pipe().subscribe(notification => {
          //   this.invalidateSubject.invalidate();
          //   this.taskManagerService.openTaskByTaskId(notification.Payload.Id, this.selectedBoard.scope);
          // });
          this.onDuplicateTaskModalClicked({board: this.selectedBoard, card: event.item.cells.Title.value, invalidateSubject:this.invalidateSubject});
          break;
        case 'Delete':
          // if(this.selectedBoard.hasOwnProperty('disableTaskDeleteFromBoard')) {
          //   if(this.selectedBoard['disableTaskDeleteFromBoard']) {
          //     this.dialogService.showDialogMessage('Warning', 'Can not delete task from this board');
          //     break;
          //   }
          // }
          // this.taskManagerService.deleteTask(event.item.cells.Title.value, this.invalidateSubject);
          this.onDeleteTaskModalClicked({board: this.selectedBoard, card: event.item.cells.Title.value, invalidateSubject:this.invalidateSubject})
          break;
        case 'Archive':
          // this.taskManagerService.archiveTask(event.item.cells.Title.value, this.invalidateSubject);
          this.onArchiveTaskModalClicked({board: this.selectedBoard, card: event.item.cells.Title.value, invalidateSubject:this.invalidateSubject})
          break;
        case 'Unarchive':
          this.taskManagerService.unArchiveTask(event.item.cells.Title.value, this.invalidateSubject);
          break;
        case 'Disable':
          this.taskManagerService.toggleTicketState(event.item.cells.Title.value, true,
            this.invalidateSubject, false);
          break;
        case 'Enable':
          this.taskManagerService.toggleTicketState(event.item.cells.Title.value, false,
            this.invalidateSubject, false);
          break;
      }
    } else {
      this.onOpenTaskModalClicked({
        board: this.selectedBoard,
        card: event.item.cells.Title.value,
        parentUrl: this.getBoardUrl(this.selectedBoard)
      });
    }
  }

  handleChange($event) {
    const config = Configuration.getSmartGridConfig(this.sourceKey);
    config.Parameters['SHOW_ARCHIVED'] = this.showArchived;
    this.invalidateSubject.invalidate();
  }

  addTask() {

  }
}
